import {
  Box,
  Button,
  Container,
  Heading,
  Stack,
  useBreakpointValue,
} from "@chakra-ui/react";
import * as React from "react";

export default function CTA() {
  return (
    <Box id="freelance" as="section" py={"8"} mx={[8, 8, 8, 8, 0]}>
      <Container
        maxW="6xl"
        py={{ base: "10", md: "12" }}
        bg="white"
        borderRadius="20"
      >
        <Stack spacing={{ base: "8", md: "10" }}>
          <Stack spacing={{ base: "4", md: "5" }} align="center">
            <Heading
              size={useBreakpointValue({ base: "lg", md: "xl" })}
              color={"gray.800"}
            >
              For any questions please drop a mail
            </Heading>
          </Stack>
          <Stack
            spacing="3"
            direction={{ base: "column", sm: "row" }}
            justify="center"
          >
            <Button
              as="a"
              variant={"ghost"}
              size="lg"
              bg={"gray.600"}
              color="white"
              href={"mailto:kurniawanflix@gmail.com"}
              transition="all ease-in 200ms"
              _hover={{
                bg: "gray.800",
                textDecoration: "none",
                px: "10",
                transition: "all ease-in 200ms",
              }}
            >
              Send an Email
            </Button>
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
}
